
  Vue.component('session-alive', {
    props: {
      interval: { type: Number, default: 1000 }
    },
    data() {
      return {
        currentUserId: null,
        timeout: null
      }
    },
    template: '#session-alive',
    computed: {},
    watch: {},
    methods: {
      ping() {
        const self = this
        axios
          .post(`/api/v1/utilities/session-alive`)
          .then(response => {
            const { data } = response
            self.currentUserId = data.currentUserId
          })
          .catch(error => {
            self.currentUserId = null
          })
          .then(() => {
            // always executed
            this.timeout = setTimeout(() => this.ping(), this.interval)
          })
      }
    },
    mounted() {
      this.ping()
    },
    beforeDestroy() {
      clearTimeout(this.timeout)
    }
  })
